import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { advanceHsaGroup } from "./schema/hsa/advance-hsa-group";
import { completeHsaSession } from "./schema/hsa/complete-hsa-session";
import { createHsaSession } from "./schema/hsa/create-hsa-session";
import { finalizeHandoffSurvey } from "./schema/hsa/finalize-handoff-survey";
import { getCurrentHsaGroup } from "./schema/hsa/get-current-hsa-group";
import { getHandoffSurveyGroup } from "./schema/hsa/get-handoff-survey-group";
import { submitHsaAnswer } from "./schema/hsa/submit-hsa-answer";

export const rpcDefinition = {
  createHsaSession,
  getCurrentHsaGroup,
  submitHsaAnswer,
  advanceHsaGroup,
  completeHsaSession,
  getHandoffSurveyGroup,
  finalizeHandoffSurvey,
};

export type CheckoutRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
